import {tns} from 'tiny-slider/src/tiny-slider';

export default (() => {

    $('.showcase-wedding .gallery').each(function() {
        tns({
            container: $(this)[0],
            items: 1,
            autoplay: false,
            autoplayButtonOutput: false,
            lazyload: false,
            speed: 2000,
            touch: true,
            controls: true,
            controlsContainer: $(this).find('controls')[0],
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
        });
    })
    
    $('.showcase-slider .gallery').each(function() {
        tns({
            container: $(this)[0],
            items: 1,
            autoplay: false,
            autoplayButtonOutput: false,
            lazyload: false,
            speed: 2000,
            touch: true,
            controls: true,
            controlsContainer: $(this).find('controls')[0],
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
        });
    })

    $('.showcase-slider').each(function() {

        if ($(this).hasClass('not-slider'))
        {
            return;
        }

        var slider = tns({
            container: $(this)[0],
            items: 1,
            autoplay: false,
            autoplayButtonOutput: false,
            lazyload: false,
            speed: 2000,
            touch: false,
            controls: false,
            nav: false,
            loop: false,
        });

        $('.showcase-heading-controls .heading-item').click(function() {
            $('.showcase-heading-controls .heading-item').removeClass('current');
            $(this).addClass('current');

            $('.showcase-heading-controls').animate({
                scrollLeft: $(this).index() * $(this).outerWidth(),
            }, 'slow');
            slider.goTo(($(this).data('index') - 1));
        })

        $('.showcase-next').click(function() {
            var index = ($(this).parents('.slide').data('index') + 1);

            if($(this).hasClass('last')) {
                $('.showcase-heading-controls .heading-item').removeClass('current');
                $('.showcase-heading-controls .heading-item[data-index="'+ index +'"]').addClass('current');

                slider.goTo('first');
                return;
            }
            
            $('.showcase-heading-controls .heading-item').removeClass('current');
            $('.showcase-heading-controls .heading-item[data-index="'+ index +'"]').addClass('current');
            slider.goTo('next');
        })
    })
});



// WEBPACK FOOTER //
// ./scripts/components/showcase-slider.js